import * as sup from "superstruct";

import { JsonApiClient } from "@/modules/api/utils/createJsonApiClient/createJsonApiClient";
import { createResponseStruct } from "@/modules/api/utils/jsonApiStructs";

import { getHandbooksListPath } from "../resources/handbooks/handbooksResourceConsts";
import { handbooksResourceStruct } from "../resources/handbooks/handbooksResourceStruct";

export const getHandbooksQuery = (
  jsonApi: JsonApiClient,
  { companyId, keywordValue }: { companyId: string; keywordValue: string }
) => {
  return jsonApi.getMany({
    path: getHandbooksListPath(companyId),
    queryParams: {
      filter: {
        name: keywordValue,
      },
    },
    responseStruct: getHandbooksResponseStruct,
  });
};

const getHandbooksResponseStruct = createResponseStruct({
  data: handbooksResourceStruct,
});

export type GetHandbooksResponse = sup.Infer<typeof getHandbooksResponseStruct>;
